export const SET_CRITERE = 'SET_CRITERE';
export const SET_COMMANDE_BAF = 'SET_COMMANDE_BAF';
export const SET_TOTAL_BAF = 'SET_TOTAL_BAF';
